<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">乡镇:</span>
          <div class="selcountry">
            <el-select v-model="adcds.adcd" clearable placeholder="请选择乡镇" @change="adcdchange(adcds.adcd)">
              <el-option
                v-for="item in adcds"
                :key="item.value"
                :label="item.adnm"
                :value="item.adcd">
              </el-option>
            </el-select>
          </div>
          <!-- <span class="xzqh">所属小流域:</span>
          <div class="selcountry">
            <el-select v-model="adcds.adcd" clearable placeholder="请选择所属小流域" @change="adcdchange(adcds.adcd)">
              <el-option
                v-for="item in adcds"
                :key="item.value"
                :label="item.adnm"
                :value="item.adcd">
              </el-option>
            </el-select>
          </div> -->
          <span id="search" @click="searchtown">查询</span>
          <span id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
          <!-- <span id="add"><span class="add-icon"></span>新增</span> -->
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column type="selection" width="50">
              </el-table-column>
              <el-table-column type="index" width="70" label="序号" align="center" header-align="center">
              </el-table-column>
              <el-table-column  align="center" prop="adcdnm" label="乡镇" min-width="180">
              </el-table-column>
               <el-table-column align="center" prop="lng"  label="经度" min-width="150">
              </el-table-column>
               <el-table-column align="center" prop="lat"  label="纬度" min-width="150">
              </el-table-column>
              <!-- <el-table-column prop="damHeight" label="所属小流域" min-width="150">
              </el-table-column> -->
              <el-table-column align="center" prop="time" label="设站日期" min-width="150">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
     <el-dialog
      class="abow_dialog"
      :title="status + '简易雨量站信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" label-width="170px" label-height="40px">
        <el-form-item label="乡镇">
          <el-select v-model="form.adcdnm" placeholder="请选择乡镇">
            <el-option
                v-for="item in adcds"
                :key="item.value"
                :label="item.adnm"
                :value="item.adcd">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="form.lat"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属小流域">
          <el-select v-model="form.landArea" placeholder="请选择所属小流域"> -->
            <!-- <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option> -->
          <!-- </el-select>
        </el-form-item> -->
        <el-form-item label="设站日期">
           <el-date-picker
            v-model="form.time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
export default {
  name: 'Scence',
  data () {
    return {
      value1: '',
      loading: true,
      height: document.documentElement.clientHeight - (document.documentElement.clientHeight * 0.3),
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
      form: { name: '' },
      addbtn: false,
      aDCD: '',
      adcdval: [],
      adcds: [],
      pageIndex: '1',
      pageSize: '100',
      tdata: [],
      isTown: true,
      searchName: '',
      delId: [],
      multipleSelection: [],
      status: '新增'
    }
  },
  computed: {
  },
  methods: {
    computeHeight () {
      var ylHeight = this.screenHeight * 0.78
      this.$refs['skt'].style.height = ylHeight + 'px'
    },
    thedata () {
      this.$store.dispatch(scenceTypes.GET_SIMPLERAIN_ANDWATER, { aDCD: this.aDCD, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        let tempData = []
        for (let i in data.results) {
          if (data.results[i].sttp === '雨量') {
            tempData.push(data.results[i])
          }
        }
        this.tdata = tempData
        console.log(this.tdata)
        this.loading = false
      })
    },
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcds = data.results
      })
    },
    adcdchange (adcd) {
      this.aDCD = adcd.substring(0, 9)
      console.log(this.aDCD)
    },
    searchtown () {
      this.thedata()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    // 新增
    addDialog () {
      this.status = '新建'
      this.form = {}
      this.addbtn = true
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.form = {}
        this.addbtn = true
        this.form = this.multipleSelection[0]
        console.log(this.form)
      }
    },
    // 删除
    delDialog (rows) {
      var _this = this
      if (rows < 1) {
        _this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        _this.delId = '' // 清空数组
        rows.forEach(item => {
          _this.delId = item.id
        })
        console.log(_this.delId)
        _this.$confirm(`确定要删除已选择的简易雨量站信息 ?`, '确认').then(() => {
          _this.loading = true
          _this.$store.dispatch(scenceTypes.DELETE_SIMPLERAIN_ANDWATER, { id: _this.delId }).then(() => {
            _this.loading = false
            _this.$notify.success({ title: '成功', message: '删除数据成功.' })
            _this.thedata()
          }).catch(() => { _this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      console.log(this.form)
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.form.sttp = '雨量'
          this.$store.dispatch(scenceTypes.SAVE_SIMPLERAIN_ANDWATER, this.form).then(() => {
            this.loading = false
            this.addbtn = false
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.form = {}
          }).catch(() => { this.loading = false })
        }
      })
    }
  },
  mounted () {
    var _this = this
    window.onresize = function () { // 定义窗口大小变更通知事件
      // _this.screenWidth = document.documentElement.clientWidth // 窗口宽度
      location.reload()
      _this.screenHeight = document.documentElement.clientHeight // 窗口高度
    }
    this.computeHeight()
    this.thedata()
    this.adcddata()
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
  height: 350px !important;
}
.scence >>> .el-form-item{
  margin-left: 1%;
  width: 44% !important;
}
.scence >>> .el-dialog__footer {
  margin-top: -30px;
}
</style>
